export enum PageViewPNF {
  REPORT = 'report',
  RETRACT = 'retract'
}

export const SIGNIN_PAGE_URL_TO_PAGE_VIEW_MAP: Record<string, PageViewPNF> = {
  '/report/infringement/retract/signin': PageViewPNF.RETRACT,
  '/report/infringement/signin': PageViewPNF.REPORT,
};

export const getPageViewForSignInPageUrl = (url: string): string => SIGNIN_PAGE_URL_TO_PAGE_VIEW_MAP[url];

export const LANDING_PAGE_URL_TO_PAGE_VIEW_MAP: Record<string, PageViewPNF> = {
  '/report/infringement': PageViewPNF.REPORT,
  '/report/infringement/retract': PageViewPNF.RETRACT,
};

export const getPageViewForLandingPageUrl = (url: string): string => LANDING_PAGE_URL_TO_PAGE_VIEW_MAP[url];

export enum CountryCode {
  AE = 'AE',
  AU = 'AU',
  BE = 'BE',
  BR = 'BR',
  CA = 'CA',
  CL = 'CL',
  CN = 'CN',
  CO = 'CO',
  DE = 'DE',
  EG = 'EG',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  IE = 'IE',
  IN = 'IN',
  IT = 'IT',
  JP = 'JP',
  MX = 'MX',
  NG = 'NG',
  NL = 'NL',
  PL = 'PL',
  SA = 'SA',
  SE = 'SE',
  SG = 'SG',
  TR = 'TR',
  US = 'US',
  ZA = 'ZA'
}

const BRAND_REGISTRY_ENROLL_URLS: Record<CountryCode, string> = {
  AE: 'https://brandservices.amazon.ae/brandregistry/eligibility?ref=BRAENF&ld=BRAENF',
  AU: 'https://brandservices.amazon.com.au/brandregistry/eligibility?ref=BRAUNF&ld=BRAUNF',
  BE: 'https://brandservices.amazon.com.be/brandregistry/eligibility?ref=BRBENF&ld=BRBENF',
  BR: 'https://brandservices.amazon.com.br/brandregistry/eligibility?ref=BRBRNF&ld=BRBRNF',
  CA: 'https://brandservices.amazon.ca/brandregistry/eligibility?ref=BRCANF&ld=BRCANF',
  CL: 'https://brandservices.amazon.cl/brandregistry/eligibility?ref=BRCLNF&ld=BRCLNF',
  CN: 'https://brandservices.amazon.com/brandregistry/eligibility?ref=BRCNNF&ld=BRCNNF',
  CO: 'https://brandservices.amazon.com.co/brandregistry/eligibility?ref=BRCLOF&ld=BRCONF',
  DE: 'https://brandservices.amazon.de/brandregistry/eligibility?ref=BRDENF&ld=BRDENF',
  EG: 'https://brandservices.amazon.eg/brandregistry/eligibility?ref=BREGNF&ld=BREDNF',
  ES: 'https://brandservices.amazon.es/brandregistry/eligibility?ref=BRESNF&ld=BRESNF',
  FR: 'https://brandservices.amazon.fr/brandregistry/eligibility?ref=BRFRNF&ld=BRFRNF',
  GB: 'https://brandservices.amazon.co.uk/brandregistry/eligibility?ref=BRUKNF&ld=BRUKNF',
  IE: 'https://brandservices.amazon.com/brandregistry/eligibility?ref=BRUSNF&ld=BRUSNF', // Note: IE is not working in Brand Registry, but included for completeness, used US instead
  IN: 'https://brandservices.amazon.in/brandregistry/eligibility?ref=BRINNF&ld=BRINNF',
  IT: 'https://brandservices.amazon.it/brandregistry/eligibility?ref=BRITNF&ld=BRITNF',
  JP: 'https://brandservices.amazon.co.jp/brandregistry/eligibility?ref=BRJPNF&ld=BRJPNF',
  MX: 'https://brandservices.amazon.com.mx/brandregistry/eligibility?ref=BRMXNF&ld=BRMXNF',
  NG: 'https://brandservices.amazon.com.ng/brandregistry/eligibility?ref=BRNGNF&ld=BRNGNF',
  NL: 'https://brandservices.amazon.nl/brandregistry/eligibility?ref=BRNLNF&ld=BRNLNF',
  PL: 'https://brandservices.amazon.pl/brandregistry/eligibility?ref=BRPLNF&ld=BRPLNF',
  SA: 'https://brandservices.amazon.sa/brandregistry/eligibility?ref=BRSANF&ld=BRSANF',
  SE: 'https://brandservices.amazon.se/brandregistry/eligibility?ref=BRSENF&ld=BRSENF',
  SG: 'https://brandservices.amazon.sg/brandregistry/eligibility?ref=BRSGNF&ld=BRSGNF',
  TR: 'https://brandservices.amazon.com.tr/brandregistry/eligibility?ref=BRTRNF&ld=BRTRNF',
  US: 'https://brandservices.amazon.com/brandregistry/eligibility?ref=BRUSNF&ld=BRUSNF',
  ZA: 'https://brandservices.amazon.co.za/brandregistry/eligibility?ref=BRZANF&ld=BRZANF',
};

export const getBREnrollUrl = (countryCode: CountryCode): string => BRAND_REGISTRY_ENROLL_URLS[countryCode];

const BRAND_REGISTRY_URLS: Record<CountryCode, string> = {
  AE: 'https://brandservices.amazon.ae/brandregistry?ref=BRAENF&ld=BRAENF',
  AU: 'https://brandservices.amazon.com.au/brandregistry?ref=BRAUNF&ld=BRAUNF',
  BE: 'https://brandservices.amazon.com.be/brandregistry?ref=BRBENF&ld=BRBENF',
  BR: 'https://brandservices.amazon.com.br/brandregistry?ref=BRBRNF&ld=BRBRNF',
  CA: 'https://brandservices.amazon.ca/brandregistry?ref=BRCANF&ld=BRCANF',
  CL: 'https://brandservices.amazon.cl/brandregistry?ref=BRCLNF&ld=BRCLNF',
  CN: 'https://brandservices.amazon.com/brandregistry?ref=BRCNNF&ld=BRCNNF',
  CO: 'https://brandservices.amazon.com.co/brandregistry?ref=BRCLOF&ld=BRCONF',
  DE: 'https://brandservices.amazon.de/brandregistry?ref=BRDENF&ld=BRDENF',
  EG: 'https://brandservices.amazon.eg/brandregistry?ref=BREGNF&ld=BREDNF',
  ES: 'https://brandservices.amazon.es/brandregistry?ref=BRESNF&ld=BRESNF',
  FR: 'https://brandservices.amazon.fr/brandregistry?ref=BRFRNF&ld=BRFRNF',
  GB: 'https://brandservices.amazon.co.uk/brandregistry?ref=BRUKNF&ld=BRUKNF',
  IE: 'https://brandservices.amazon.com/brandregistry?ref=BRUSNF&ld=BRUSNF', // Note: IE is not working in Brand Registry, but included for completeness, used US instead
  IN: 'https://brandservices.amazon.in/brandregistry?ref=BRINNF&ld=BRINNF',
  IT: 'https://brandservices.amazon.it/brandregistry?ref=BRITNF&ld=BRITNF',
  JP: 'https://brandservices.amazon.co.jp/brandregistry?ref=BRJPNF&ld=BRJPNF',
  MX: 'https://brandservices.amazon.com.mx/brandregistry?ref=BRMXNF&ld=BRMXNF',
  NG: 'https://brandservices.amazon.com.ng/brandregistry?ref=BRNGNF&ld=BRNGNF',
  NL: 'https://brandservices.amazon.nl/brandregistry?ref=BRNLNF&ld=BRNLNF',
  PL: 'https://brandservices.amazon.pl/brandregistry?ref=BRPLNF&ld=BRPLNF',
  SA: 'https://brandservices.amazon.sa/brandregistry?ref=BRSANF&ld=BRSANF',
  SE: 'https://brandservices.amazon.se/brandregistry?ref=BRSENF&ld=BRSENF',
  SG: 'https://brandservices.amazon.sg/brandregistry?ref=BRSGNF&ld=BRSGNF',
  TR: 'https://brandservices.amazon.com.tr/brandregistry?ref=BRTRNF&ld=BRTRNF',
  US: 'https://brandservices.amazon.com/brandregistry?ref=BRUSNF&ld=BRUSNF',
  ZA: 'https://brandservices.amazon.co.za/brandregistry?ref=BRZANF&ld=BRZANF',
};

export const getBRUrl = (countryCode: CountryCode): string => BRAND_REGISTRY_URLS[countryCode];

const SELLER_CENTRAL_URLS: Record<CountryCode, string> = {
  AE: 'https://sellercentral.amazon.ae/',
  AU: 'http://sellercentral.amazon.com.au/',
  BE: 'https://sellercentral.amazon.com.be/',
  BR: 'https://sellercentral.amazon.com.br/',
  CA: 'https://sellercentral.amazon.ca/',
  CL: 'https://sellercentral.amazon.cl/',
  CN: 'https://sellercentral.amazon.com',
  CO: 'https://sellercentral.amazon.com.co/',
  DE: 'https://sellercentral.amazon.de/',
  EG: 'https://sellercentral.amazon.eg/',
  ES: 'https://sellercentral.amazon.es/',
  FR: 'https://sellercentral.amazon.fr/',
  GB: 'https://sellercentral.amazon.co.uk/',
  IE: 'https://sellercentral.amazon.ie/',
  IN: 'https://sellercentral.amazon.in/',
  IT: 'https://sellercentral.amazon.it/',
  JP: 'https://sellercentral.amazon.co.jp/',
  MX: 'https://sellercentral.amazon.com.mx/',
  NG: 'https://sellercentral.amazon.com.ng/',
  NL: 'https://sellercentral.amazon.nl/',
  PL: 'https://sellercentral.amazon.pl/',
  SA: 'https://sellercentral.amazon.sa/',
  SE: 'https://sellercentral.amazon.se/',
  SG: 'https://sellercentral.amazon.sg/',
  TR: 'http://sellercentral.amazon.com.tr/',
  US: 'https://sellercentral.amazon.com/',
  ZA: 'https://sellercentral.amazon.co.za/',
};

export const getSellerCentralUrl = (countryCode: CountryCode): string => SELLER_CENTRAL_URLS[countryCode];

const AMAZON_ORDERS_URLS: Record<CountryCode, string> = {
  AE: 'https://amazon.ae/yourorders',
  AU: 'https://amazon.com.au/yourorders',
  BE: 'https://amazon.com.be/yourorders',
  BR: 'https://amazon.com.br/yourorders',
  CA: 'https://amazon.ca/yourorders',
  CL: 'https://amazon.cl/yourorders',
  CN: 'https://amazon.cn/yourorders',
  CO: 'https://amazon.com.co/yourorders',
  DE: 'https://amazon.de/yourorders',
  EG: 'https://amazon.eg/yourorders',
  ES: 'https://amazon.es/yourorders',
  FR: 'https://amazon.fr/yourorders',
  GB: 'https://amazon.co.uk/yourorders',
  IE: 'https://amazon.ie/yourorders',
  IN: 'https://amazon.in/yourorders',
  IT: 'https://amazon.it/yourorders',
  JP: 'https://amazon.co.jp/yourorders',
  MX: 'https://amazon.com.mx/yourorders',
  NG: 'https://amazon.com.ng/yourorders',
  NL: 'https://amazon.nl/yourorders',
  PL: 'https://amazon.pl/yourorders',
  SA: 'https://amazon.sa/yourorders',
  SE: 'https://amazon.se/yourorders',
  SG: 'https://amazon.sg/yourorders',
  TR: 'https://amazon.com.tr/yourorders',
  US: 'https://amazon.com/yourorders',
  ZA: 'https://amazon.co.za/yourorders',
};

export const getAmazonOrdersUrl = (countryCode: CountryCode): string => AMAZON_ORDERS_URLS[countryCode];

const CONTACT_US_URLS_SELLERS: Record<string, string> = {
  AE: 'https://sellercentral.amazon.ae/gp/contact-us/contact-amazon-form.html/ref=id_contactus_cont_200700310',
  BE: 'https://sellercentral.amazon.com.be/gp/contact-us/contact-amazon-form.html/ref=id_contactus_cont_200700310',
  DE: 'https://sellercentral.amazon.de/gp/contact-us/contact-amazon-form.html',
  EG: 'https://sellercentral.amazon.eg/gp/contact-us/contact-amazon-form.html/ref=id_contactus_cont_200700310',
  GB: 'https://sellercentral.amazon.co.uk/gp/contact-us/contact-amazon-form.html/ref=id_contactus_cont_200700310',
  NL: 'https://sellercentral.amazon.nl/gp/contact-us/contact-amazon-form.html/ref=id_contactus_cont_200700310?',
  PL: 'https://sellercentral.amazon.pl/gp/contact-us/contact-amazon-form.html/ref=id_contactus_cont_200700310',
  SA: 'https://sellercentral.amazon.sa/gp/contact-us/contact-amazon-form.html',
};

const CONTACT_US_URLS_BUYERS: Record<string, string> = {
  AE: 'https://www.amazon.ae/gp/help/customer/display.html/ref=hp_bc_nav?ie=UTF8&nodeId=201889680',
  BE: 'https://www.amazon.com.be/gp/help/customer/display.html/ref=hp_bc_nav?ie=UTF8&nodeId=201889680',
  EG: 'https://www.amazon.eg/gp/help/customer/display.html/ref=hp_bc_nav?ie=UTF8&nodeId=201889680',
  GB: 'https://www.amazon.co.uk/gp/help/customer/display.html/ref=hp_bc_nav?ie=UTF8&nodeId=201889680',
  SA: 'https://www.amazon.sa/gp/help/contact-us/general-questions.html',
};

const INTELECTUAL_PROPERTY_POLICY_URLS: Record<string, string> = {
  AE: 'https://sellercentral.amazon.ae/gp/help/201361070',
  BE: 'https://sellercentral.amazon.com.be/gp/help/external/201361070',
  EG: 'https://sellercentral.amazon.eg/gp/help/201361070',
  GB: 'https://sellercentral.amazon.co.uk/gp/help/external/201361070',
  NL: 'https://sellercentral.amazon.nl/gp/help/external/201361070',
  PL: 'https://sellercentral.amazon.pl/gp/help/external/U5SQCEKADDAQRLZ',
  TR: 'https://sellercentral.amazon.com.tr/gp/help/external/201361070',
}

export enum ContactUsType {
  SELLER = 'seller',
  BUYER = 'buyer',
  IP = 'ip'
}

export const contactUsFormUrls = (countryCode: CountryCode, type: ContactUsType): string => {
  if (type === ContactUsType.SELLER) {
    if (CONTACT_US_URLS_SELLERS[countryCode]) {
      return CONTACT_US_URLS_SELLERS[countryCode];
    }
    return 'https://sellercentral.amazon.com/gp/contact-us/contact-amazon-form.html';
  } else if (type === ContactUsType.IP) {
    if (INTELECTUAL_PROPERTY_POLICY_URLS[countryCode]) {
      return INTELECTUAL_PROPERTY_POLICY_URLS[countryCode];
    }
    return 'https://sellercentral.amazon.com/gp/help/external/U5SQCEKADDAQRLZ';
  } else {
    if (CONTACT_US_URLS_BUYERS[countryCode]) {
      return CONTACT_US_URLS_BUYERS[countryCode];
    }
    return 'https://www.amazon.com/gp/help/customer/display.html/ref=hp_bc_nav?ie=UTF8&nodeId=201889680';
  }
}
